// eslint-disable-next-line
export default function setRemoval (target, options={}) { 

    this.item.removed = (!!target);

    return this;

}